import { EyeInvisibleOutlined } from '@ant-design/icons';
import { type Editor } from '@tiptap/react';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { RichTextButton } from '../RichTextMenuButton.tsx';

interface IRichTextOmissisButtonProps {
  editor: Editor | null;
}

export function RichTextOmissisButton(props: IRichTextOmissisButtonProps) {
  const { editor } = props;
  const { t } = useTranslation();

  const isCommandRegistered = useMemo(() => {
    return typeof editor?.commands?.toggleOmissis === 'function';
  }, [editor]);

  const toggleOmissis = useCallback(() => {
    if (!editor || !isCommandRegistered) return;
    editor.chain().focus().toggleOmissis().run();
  }, [editor, isCommandRegistered]);

  if (!editor || !isCommandRegistered) return null;

  return (
    <RichTextButton
      icon={<EyeInvisibleOutlined />}
      isActive={!!editor.isActive('omissis')}
      title={t('inputs.rich-text-menu-bar.omissis', 'Omissis')}
      onClick={toggleOmissis}
      disabled={!editor.isEditable}
    />
  );
}
